/**
 * The organization's lists that teachers pick from: error types (B6) and attendance states (B14).
 * The administration names, orders and archives them; archived entries stay on past records.
 */
import { z } from "zod";
const name = z.string().trim().min(2, "الاسم قصير").max(60);
export const CatalogErrorType = z.object({
    id: z.uuid(),
    name: z.string(),
    ordinal: z.number(),
    archived: z.boolean(),
});
export const CatalogErrorTypesResponse = z.object({ errorTypes: z.array(CatalogErrorType) });
export const CreateErrorTypeBody = z.object({ organizationId: z.uuid(), name });
export const UpdateErrorTypeBody = z.object({
    name: name.optional(),
    ordinal: z.number().int().min(0).max(999).optional(),
    archived: z.boolean().optional(),
});
export const CatalogAttendanceStatus = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    countsAsPresent: z.boolean(),
    ordinal: z.number(),
    archived: z.boolean(),
    /** «حاضر» is what a live recitation records; it cannot be archived. */
    system: z.boolean(),
});
export const CatalogAttendanceStatusesResponse = z.object({ statuses: z.array(CatalogAttendanceStatus) });
export const CreateAttendanceStatusBody = z.object({
    organizationId: z.uuid(),
    name,
    countsAsPresent: z.boolean(),
});
export const UpdateAttendanceStatusBody = z.object({
    name: name.optional(),
    countsAsPresent: z.boolean().optional(),
    ordinal: z.number().int().min(0).max(999).optional(),
    archived: z.boolean().optional(),
});
//# sourceMappingURL=catalogs.js.map